export default "__VITE_ASSET__5e7ee1e9__"